import { Address } from './address';

export function getCorrectSubscriptionIdFromAddress(address: Address | null): string | null {
  if (!address) {
    return null;
  }

  const currentSubscriptionFromList = address.addressSubscriptions?.find(
    (sub) => sub.status !== 'canceled',
  );

  return currentSubscriptionFromList?.stripeSubscriptionId ?? null;
}
